var HEADER_ROW_STYLES = {
  px: '12',
  py: '4',
  display: 'flex',
  alignItems: 'center',
  gap: '12',
  minHeight: '36px'
};

export { HEADER_ROW_STYLES };
//# sourceMappingURL=constants.js.map
